import { Component, Input, NgZone, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { CNConsultation } from 'src/app/models/cnconsultation';
import { CNServiceCode } from 'src/app/models/cnservicecode';
import * as moment from 'moment';
import { BecareService } from 'src/app/services/becare.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ContactServicesDialogComponent } from 'src/app/dialogs/contact/contact-services-dialog/contact-services-dialog.component';
import { ContactService } from 'src/app/services/contact.service';

declare var Ext: any;

@Component({
  selector: 'app-contact-services-row',
  templateUrl: './contact-services-row.component.html',
  styleUrls: ['./contact-services-row.component.scss']
})
export class ContactServicesRowComponent implements OnInit {

  displayedColumns: string[] = ['code', 'label'];

  private theContact: CNConsultation;
  private usingNewDialogs = true;
  public codes: CNServiceCode[] = [];
  @Input() collapsed = true;

  constructor(private ngZone: NgZone, private becare: BecareService, private dialog: MatDialog,
              private contacts: ContactService) { }

  ngOnInit(): void {
  }

  @Input() set contact(contact: CNConsultation) {
    this.theContact = contact;
    this.codes = contact.contactService?.serviceCodes;
  }

  get contact(): CNConsultation {
    return this.theContact;
  }

  edit() {
    if (this.usingNewDialogs) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        contact: this.theContact
      };
      const dialogRef = this.dialog.open(ContactServicesDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        if (result && result instanceof CNConsultation) {
          // save this contact
          this.contacts.save(result);
        } else {
          // reload contacts
          this.contacts.load();
        }
      });
    } else {
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          // Open old consultation interface
          const consultationWindow = new Ext.CNConsultationWindow({
            consultationid: this.theContact.id,
            displayconsult: false,
            displayservicecode: true,
            prestataireid: this.theContact.healthagentid,
            consultDate: moment(this.theContact.date).format('DD/MM/YYYY'),
            closewhensaved: true,
            displaybillbutton: false,
            paid: (this.theContact.getProperty('paid') === 'true') ? true : false,
            source: 'consultationlist'
          });
          consultationWindow.on('close', () => {
            console.log('window closed');
          });
          consultationWindow.show();
        });
      });
    }
  }

  print() {
    // this.becare.call('/fr/services/contact/' + this.theContact.id + '/print', [], '', 'post').subscribe(result => {
    // });
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        // Open old interface
        const entryAccountWindow = new Ext.CNAccountEntryWindow({
          consultationid: this.theContact.id,
          consultationdate: moment(this.theContact.date).format('DD/MM/YYYY'),
          patientid: this.theContact.contactService.getProperty('patientid'),
          healthagentid: this.theContact.healthagentid,
          displaybilling: false,
          displaytemplates: true
        });
        entryAccountWindow.show();
        entryAccountWindow.on('added', () => {
          entryAccountWindow.hide();
          setTimeout(() => {
            this.reloadContact();
          });
        });
      });
    });
  }

  validate() {
    this.theContact.validate();
  }

  pay() {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        // Open old interface
        const entryAccountWindow = new Ext.CNAccountEntryWindow({
          consultationid: this.theContact.id,
          consultationdate: moment(this.theContact.date).format('DD/MM/YYYY'),
          patientid: this.theContact.contactService.getProperty('patientid'),
          healthagentid: this.theContact.healthagentid,
          displaytemplates: true
        });
        entryAccountWindow.show();
        entryAccountWindow.on('added', () => {
          entryAccountWindow.hide();
          setTimeout(() => {
            this.reloadContact();
          });
        });
      });
    });
  }

  reloadContact() {
    this.ngZone.run(() => {
      this.theContact.reload();
    });
  }
}
